<template>
  <div>
    <b-modal
      title="DETALHES DO SERVIÇO"
      id="details"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <details-service :service="service" />
    </b-modal>
    <div class="row">
      <div class="col-md-4">
        <select
          class="form-control form-control-sm"
          v-model="service_id"
          @change="handleFilter"
        >
          <option :value="null">TODOS</option>
          <option v-for="(item, key) in services" :key="key" :value="item.id">
            {{ item.description }}
          </option>
        </select>
      </div>
      <Filters @paginate="handleFilters" :loading="loading" />
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length === 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <div class="text-right mb-2" v-show="data.length > 0">
        <confirmation-dialog
          headerClass="modal-header-info"
          :loading="loadingExecute"
          :disabled="loadingExecute || selectedIds.length == 0"
          message-title="FINALIZAR?"
          message-body="Deseja realmente alterar para FATURADO?"
          open-class="btn-notcertified"
          open-left-icon="fa-check"
          open-text="FINALIZAR FATURAMENTO(S) PENDENTE(S) SELECIONADO(S)"
          @yes="execute"
        />
      </div>
      <v-data-table
        v-model="selected"
        show-select
        v-show="data.length > 0"
        dense
        :headers="headers"
        :items="data"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
      >
        <template v-slot:[`item.status`]="{ item }">
          <small>FATURAMENTO PENDENTE</small>
          <v-icon class="ml-2" small color="orange">
            mdi-information-outline
          </v-icon>
          <input type="hidden" :value="item.status" />
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ moment(item.date).format("DD/MM/YYYY") }}
        </template>
        <template v-slot:[`item.service_charge_type`]="{ item }">
          {{ item.service_charge_type_name }}
        </template>
        <template v-slot:[`item.quantity`]="{ item }">
          {{ item.quantity }}
        </template>
        <template v-slot:[`item.service`]="{ item }">
          {{ item.service_description }}
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-btn x-small class="btn-primary m-1" @click="handleDetails(item)">
            <i class="fas fa-eye mr-2"></i>DETALHES
          </v-btn>
        </template>
      </v-data-table>
      <div class="text-right" v-show="data.length > 0">
        <confirmation-dialog
          headerClass="modal-header-info"
          :loading="loadingExecute"
          :disabled="loadingExecute || selectedIds.length == 0"
          message-title="FINALIZAR?"
          message-body="Deseja realmente alterar para FATURADO?"
          open-class="btn-notcertified"
          open-left-icon="fa-check"
          open-text="FINALIZAR FATURAMENTO(S) PENDENTE(S) SELECIONADO(S)"
          @yes="execute"
        />
      </div>
    </b-overlay>
    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";

import Filters from "../../Components/Filters.vue";

import DetailsService from "./service/details.vue";

import api from "../../../services/api";

import routes from "../../../routes";

import { formatPrice } from "../../../lib/format";

import moment from "moment";

import toast from "../../../lib/ToastNotification";

export default {
  name: "Invoicing",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    Filters,
    DetailsService,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      month: moment().format("YYYY-MM"),
      dayMonthYear: "month",

      selectedIds: [],
      selected: [],

      status: 1,
      service_id: null,
      resident_id: "",

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "DATA DO SERVIÇO", value: "date", sortable: false },
        { text: "SERVIÇO", value: "service", sortable: false },
        {
          text: "TIPO DE COBRANÇA",
          value: "service_charge_type",
          sortable: false,
        },
        { text: "QUANTIDADE", value: "quantity", sortable: false },
        { text: "AÇÕES", value: "details", sortable: false },
      ],

      data: [],

      services: [],

      service: {},

      loading: false,
      loadingExecute: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },

    selected() {
      this.selectedIds = this.selected.map((select) => select.id);
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatPrice,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.paginate();
      this.getServices();
    },

    async getServices() {
      try {
        const response = await api.get("/rest-home/service/paginate");

        const { error, errors, services } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.services = services;
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleDetails(service) {
      this.service = service;
      this.$bvModal.show("details");
    },

    handleFilters(filters) {
      let { month, dayMonthYear } = filters;

      this.month = month;
      this.dayMonthYear = dayMonthYear;

      this.paginate();
    },

    handleFilter() {
      this.options.page = 1;
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, service_id, status, month, dayMonthYear } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          service_id,
          page,
          itemsPerPage,
          status,
          month,
          dayMonthYear,
        };

        const response = await api.get("/rest-home/resident/services", {
          params,
        });

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loadingExecute = true;

        const { resident_id, selectedIds } = this;

        let params = {
          resident_id,
          items: selectedIds,
          status: 0,
        };

        const response = await api.put(
          "/rest-home/financial/launch/pay/service-pending-billing",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.selectedIds = [];
          this.paginate();
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingExecute = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
